import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  container: ({ paginationBullet, paginationBulletActive }: { paginationBullet?: string; paginationBulletActive?: string }) => css`
    .swiper-button-prev,
    .swiper-button-next {
      background-color: red;
      width: 100px;
      height: 100px;
    }
    .swiper-pagination-bullet {
      opacity: 1;
      height: 12px;
      width: 12px;
      background-color: ${paginationBullet || "#00386380"};
    }
    .swiper-pagination-bullet-active {
      height: 16px;
      width: 16px;
      background-color: ${paginationBulletActive || "#0045b5"};
    }
    .swiper-pagination-bullets {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      margin-top: 34px;
    }
    .swiper-slide {
      padding-bottom: 2px;
      width: auto;
      ${theme.breakpoints.down("sm")} {
        flex: 1;
        width: 100%;
      }
    }
  `,
  navigation_container: css`
    ${theme.breakpoints.down("sm")} {
      display: none;
    }
  `
};
